import {
  AddCircleFilledIcon,
  CancelFilledIcon,
  checkIcon,
  DownloadedIcon,
  HighlightOffFilledIcon,
  RemoveRedEyeFilledIcon,
  UpdateFilledIcon,
} from '@assets';

export const rateConStatusBgAndTextColor = {
  viewed: 'bg-[#CCEEFF] text-[#123B50]',
  accepted: 'bg-[#CEF1E9] text-[#248670]',
  delivered: 'bg-[#CCEEFF] text-[#123B50]',
  cancelled: 'bg-[#CFD8DC] text-[#37474F]',
  expired: 'bg-[#FFF8E1] text-[#FF6F00]',
  rejected: 'bg-[#FBE9E7] text-[#8D001A]',
  pending: 'bg-[#CFD8DC] text-[#37474F]',
  downloaded: 'bg-[#CCEEFF] text-[#123B50]',
  terms_accepted: 'bg-[#CEF1E9] text-[#248670]',
};

export const statusImgIcon = {
  viewed: RemoveRedEyeFilledIcon,
  accepted: checkIcon,
  delivered: AddCircleFilledIcon,
  cancelled: CancelFilledIcon,
  expired: UpdateFilledIcon,
  rejected: HighlightOffFilledIcon,
  downloaded: DownloadedIcon,
  terms_accepted: checkIcon,
};

export const getRateConStatusClass = (status?: string) => {
  return status && status in rateConStatusBgAndTextColor
    ? rateConStatusBgAndTextColor[
        status as keyof typeof rateConStatusBgAndTextColor
      ]
    : '';
};

export const getRateConActionIcon = (actionType?: string) => {
  return actionType && actionType in statusImgIcon
    ? statusImgIcon[actionType as keyof typeof statusImgIcon]
    : undefined;
};
